import React, { FunctionComponent } from "react";
import { NamedProperty } from "sprint-common-web";

import { MovieContentSubtype } from "../../../../../common/types/MovieContentSubtype";
import { VersionSummary } from "../../../../../common/types/VersionSummary";
import { PageHeader } from "../../../../../common/ui/layout/header/PageHeader";
import { MovieDetailsPageBreadcrumbs } from "../../../common/header/movie/MovieDetailsPageBreadcrumbs";

interface MovieDetailsPageHeaderProps {
    contentType: MovieContentSubtype;
    movie: NamedProperty;
    version: VersionSummary;
}

export const OnPremMovieDetailsPageHeader: FunctionComponent<MovieDetailsPageHeaderProps> = (
    props: MovieDetailsPageHeaderProps
) => {
    const { contentType, movie, version } = props;

    return (
        <PageHeader>
            <MovieDetailsPageBreadcrumbs contentType={contentType} movie={movie} version={version} />
        </PageHeader>
    );
};
